export default __webpack_public_path__ + "static/media/w51Exterior.9ebc2f63.jpg";